<template>
    <v-dialog max-width="500px" content-class="add">
        <template v-slot:activator="{ on, attrs }">

            <v-btn color="primary" dark  v-bind="attrs" v-on="on">
                    <v-icon small>mdi-plus</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newMember || "New member" }}</span>
                </v-btn>
        </template>
        <template v-slot:default="newMemberModal">
        <v-card>
            <v-toolbar elevation="0">
                <v-toolbar-title>{{ $page.props.lang.newMember || "New member" }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon  @click="newMemberModal.value = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="mt-4">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <p class="custom-label">{{ $page.props.lang.firstName || 'First name' }}</p>
                            <v-text-field v-model="newMember.first_name"
                                :error-messages="responseErrors.first_name"
                                :hide-details="!responseErrors.first_name"
                                @focus="responseErrors.first_name=''"
                                outlined dense solo flat></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <p class="custom-label">{{ $page.props.lang.lastName || 'Last name' }}</p>
                            <v-text-field v-model="newMember.last_name"
                                :error-messages="responseErrors.last_name"
                                :hide-details="!responseErrors.last_name"
                                @focus="responseErrors.last_name=''"
                                outlined dense solo flat></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <p class="custom-label">{{ $page.props.lang.birthDate || 'Day of birth' }}</p>
                            <v-menu
                                ref="birthDatePicker"
                                v-model="birthDatePicker"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="formatDatePicker"
                                        append-icon="mdi-menu-down" outlined dense readonly v-bind="attrs" v-on="on"
                                        @click:append="birthDatePicker = true" class="birth-date"
                                        :hide-details="!responseErrors.birth_date"></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="newMember.birth_date"
                                        locale="sr-Latn"
                                        :min="minBirth" :max="yesterday"
                                        :active-picker.sync="activePicker"
                                         @input="birthDatePicker = false"
                                        :first-day-of-week="1" no-title scrollable color="primary">
                                        <v-spacer></v-spacer>

                                    </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <p class="custom-label">{{ $page.props.lang.gender || 'Gender' }}</p>
                            <v-select v-model="newMember.gender"
                                :items="gender"
                                :error-messages="responseErrors.gender" @change="responseErrors.gender=''"
                                :hide-details="!responseErrors.gender"
                                outlined dense></v-select>
                        </v-col>
                        <v-col cols="12">
                            <p class="custom-label">{{ $page.props.lang.email || 'E-mail' }}</p>
                            <v-text-field v-model="newMember.email"
                                :error-messages="responseErrors.email"
                                @focus="responseErrors.email=''"
                                :hide-details="!responseErrors.email"
                                outlined dense solo flat></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <p class="custom-label">{{ $page.props.lang.phone || 'Phone number' }}</p>
                            <v-text-field  :placeholder="country_code + 'xxxx...'" v-model="newMember.phone_number"
                                :error-messages="responseErrors.phone_number"
                                @focus="responseErrors.phone_number=''"
                                :hide-details="!responseErrors.phone_number"
                                outlined dense solo flat></v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="newMemberModal.value = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                        <v-btn :loading="saving" @click="addMember" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                    </v-card-actions>
                </v-container>
            </v-card-text>
        </v-card>
        </template>
    </v-dialog>
</template>

<script>
import EventBus from '@/js/eventbus'
export default {
    props:{
        lang: Object,
        country_code: String,
    },
    data(){
        return {
            birthDatePicker: false,
            activePicker: null,
            date: moment().format('YYYY-MM-DD'),
            minBirth: moment().subtract(100, 'years').format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            newMember: {
                first_name: '',
                last_name: '',
                birth_date: null,
                gender: '',
                email: '',
                phone_number: '',
                note: ''
            },
            resetMember: {
                first_name: '',
                last_name: '',
                birth_date: null,
                gender: '',
                email: '',
                phone_number: '',
                note: ''
            },
            responseErrors: {},
            saving: false,
        }
    },
    computed: {
        gender() {
            let male = this.lang.male || 'Male'
            let female = this.lang.female || 'Female'
            let other = this.lang.other || 'Other'
            return [
                {text: male, value: 0},
                {text: female, value: 1},
                {text: other, value: 2}
            ]
        },

        formatDatePicker(){
            if(this.newMember.birth_date !== null){
                return moment(this.newMember.birth_date).format('D.M.Y.');
            }else{
                return null;
            }
        }
    },
    watch: {
        birthDatePicker (val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        newMemberModal:  {
            handler (val, oldVal) {
                if (val===false) {
                    this.newMember = Object.assign({}, this.resetMember)
                    this.responseErrors = this.resetErrors
                }
            },
            deep: true,
        },

    },
    methods:{

        addMember() {
            this.saving = true;
            axios.post('/backoffice/members/store', this.newMember)
                .then(response => {
                    this.saving = false;
                    if (response.data.status==="OK") {
                        this.$inertia.visit('/backoffice/members/details/' + response.data.member.id, { method: 'get' })
                    }
                })
                .catch(error => {
                    this.saving = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },
    }
}
</script>
